import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { useBloqueioTipoSelect } from "@/Services/Pessoa/Bloqueio/BloqueioTipoService";

interface IBloqueioTipoSelectProps extends ISelectComPesquisaProps {
    filtros?:Parameters<typeof useBloqueioTipoSelect>[0];
}

export default function BloqueioTipoSelect({
    loading,
    placeholder,
    allowClear,
    filtros,
    value,
    ...rest
}:IBloqueioTipoSelectProps) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? undefined;
    filtros = filtros ?? {
        pessoaGenero : undefined,
        ativo : true
    }

    const {
        data,
        isLoading,
        isFetching
    } = useBloqueioTipoSelect({
        ...filtros
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || isFetching || loading}
        value={value}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}